module.exports = __webpack_public_path__ + "img/stop-button.232900c8.png";